import { mapState, mapMutations } from 'vuex';
import ApiService from '@/services/apiService';
import { themesMixin } from '@/utils/themes';
import debounce from 'lodash/debounce';
const DEBOUNCE_TIME = 250;
export default {
  name: 'ViewChangePassword',
  mixins: [themesMixin],
  data: function () {
    return {
      valid: false,
      password: '',
      passwordConfirm: '',
      marker: false,
      tenantName: null,
      passwordError: null,
      debouncedValidatePassword: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'CustomTheme']),
    token() {
      return this.$route.query.token;
    },
    passwordHasError() {
      return this.passwordError && typeof this.passwordError === 'string';
    },
    loginLogo() {
      return this.themeGetLogoObject();
    },
    loginBackground() {
      return this.themeGetBackground();
    },
    passwordConfirmRules() {
      return [v => !!v && v === this.password || this.$i18n_t('accMgmt.user.pwdMissmatch')];
    },
    passwordRules() {
      return [v => !!v || this.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED'), v => {
        if (!!v && this.debouncedValidatePassword) {
          this.debouncedValidatePassword();
        }
        return true;
      }];
    }
  },
  mounted() {
    document.getElementsByTagName('html')[0].classList.add('hide__scrollbar');
    this.debouncedValidatePassword = debounce(this.validatePassword, DEBOUNCE_TIME);
  },
  beforeDestroy() {
    document.getElementsByTagName('html')[0].classList.remove('hide__scrollbar');
  },
  methods: {
    ...mapMutations('app', ['snackbar']),
    async handleSubmit() {
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.submitted = true;
      try {
        await this.validate();
        if (!this.valid) {
          return;
        }
        await ApiService.resetPasswordWithToken(this.token, this.password);
        this.$snack(this.$i18n_t('accMgmt.user.pwdChgSuccess'), 'success');
        try {
          await this.$store.dispatch('authentication/logout');
        } catch (logoutError) {
          console.warn('Logout failed, but continuing with redirect:', logoutError);
        }

        // use window.location for reliable redirect after password change
        // $router.replace('/login') would be the more SPA way, but we are
        // logged out anyway, so we prefer reliability over SPA-ness
        window.location.replace('/login');
      } catch (error) {
        if (error.response && this.$i18n_te(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else if (error.response && this.$i18n_te(`accMgmt.user.passwordErrors.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`accMgmt.user.passwordErrors.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('accMgmt.user.pwdChgFail'), 'error');
        }
      } finally {
        this.$store.state.app.loading = false;
        this.$store.state.app.load = 0;
      }
    },
    async validate() {
      this.valid = this.$refs.form.validate();
      if (this.valid && this.password) {
        await this.validatePassword();
      }
      if (this.valid) {
        this.snackbar = true;
      }
    },
    async validatePassword() {
      const result = await ApiService.validateUserPassword(this.password, undefined, this.token);
      if (typeof result === 'string') {
        const matches = result.match(/(.+?)_([0-9]+)$/);
        // special handling: length is encoded in error-message
        if (matches && matches.length) {
          let length = parseInt(matches[2]);
          let message = matches[1];
          this.passwordError = this.$i18n_tc(`accMgmt.user.passwordErrors.${message}`, length, {
            n: length
          });
        } else {
          this.passwordError = this.$i18n_t(`accMgmt.user.passwordErrors.${result}`);
        }
      } else {
        this.passwordError = null;
      }
    }
  }
};